import { Box, Grid, Typography } from "@mui/material"


export const InformationUI = ({ Title, Data }) => {

    return (<>
        <Box sx={{ height: "auto", width: "100%", borderRadius: "10px" }}>
            {Title && <Box p={2} sx={{ borderBottom: "1px solid #1D013B", backgroundColor: "rgba(29, 1, 59, 0.1)" }}>
                <Typography variant='h4' color={"#1D013B"}>{Title}</Typography>
            </Box>}
            {Data?.length > 0 && <Grid container p={2} pt={0} md={12}>
                {Data.map((item, index) => (
                    !item?.isField && <>
                        <Grid item mt={2} md={4} xs={12} sm={12} key={`label-${index}`} border= {"1px solid #dddddd"} p={2} sx={{ overflowWrap: "break-word", wordBreak: "break-word" }}>
                            <Typography fontWeight="bold" variant="h6" sx={{ overflowWrap: "break-word", wordBreak: "break-word" }}>{item.label}</Typography>
                        </Grid>
                        <Grid p={2} border={"1px solid #dddddd"} item mt={2} md={item.IsFullLine ? 8 : 8} xs={12} sm={12} key={`value-${index}`} sx={{ overflowWrap: "break-word", wordBreak: "break-word" }}>
                            <Typography variant="h6" sx={{ display: "flex", justifyContent: "flex-start", color: "#808080", overflowWrap: "break-word", wordBreak: "break-word" }}>
                                {item?.isArray && Array.isArray(item.value) ? item.value.map(str => str.charAt(0).toUpperCase() + str.slice(1)).join(", ") : item.value}
                            </Typography>
                        </Grid>
                    </>
                ))}
            </Grid>}
        </Box>
    </>)
}